import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concat, EMPTY, from, Observable, of } from 'rxjs';
import { catchError, switchMap, map, tap } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { downloadFile } from '../../global/fileDownload';
import { HttpService } from '../../global/http.service';
import { DatesInterval, DatesIntervalRequest } from '../../global/interfaces';

import * as esg from './esg.actions';
import { EsgData, EsgRequestPayload } from './esg.models';
import * as moment from 'moment';
import { Actions as ActionsCDK } from "atlas-cdk";
import { ToastService } from '../../shared/toaster_/toaster_.service';

@Injectable()
export class EsgEffects {

    public loadEsgDates$ = createEffect(() => this.actions$.pipe(
        ofType<esg.LoadEsgsDatesAction>(esg.ActionTypes.LOAD_ESG_DATES),
        map(action => action.payload),
        switchMap((payload: DatesIntervalRequest) =>
            this.loadEsgDates(payload).pipe(
                map((response: DatesInterval) =>
                    new esg.LoadEsgDatesSuccessAction(response)
                ),
                catchError(error =>
                    // from([
                    //     new esg.LoadEsgDatesFailedAction(error),
                    //     new AddErrorToastAction(!isNullOrUndefined(error.error)
                    //         && !isNullOrUndefined(error.error.message) ? error.error.message : error.message)
                    // ]
                    // )
                    // {
                    //     this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
                    //     return of(new esg.LoadEsgDatesFailedAction(error));
                    // }
                    concat(
                        of(new esg.LoadEsgDatesFailedAction(error)),
                        of(null).pipe(
                            tap(() => {
                                const errorMessage = (error?.error != null && error.error.message != null)
                                    ? error.error.message
                                    : error.message;
                                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
                            })
                        )
                    )
                )
            )
        )
    ));

    public loadEsg$ = createEffect(() => this.actions$.pipe(
        ofType<esg.LoadEsgAction>(esg.ActionTypes.LOAD_ESG),
        map(action => action.payload),
        switchMap((payload: EsgRequestPayload) =>
            this.loadEsg(payload).pipe(
                map((response: any) =>
                    new esg.LoadEsgSuccessAction(response)
                ),
                catchError(error =>
                    // from([
                    //     new esg.LoadEsgFailedAction(error),
                    //     new AddErrorToastAction(!isNullOrUndefined(error.error)
                    //         && !isNullOrUndefined(error.error.message) ? error.error.message : error.message)
                    // ])
                    // {
                    //     this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
                    //     return of(new esg.LoadEsgFailedAction(error));
                    // }
                    concat(
                        of(new esg.LoadEsgFailedAction(error)),
                        of(null).pipe(
                            tap(() => {
                                const errorMessage = (error?.error != null && error.error.message != null)
                                    ? error.error.message
                                    : error.message;
                                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
                            })
                        )
                    )
                )

            )
        )
    ));

    public fileDownload$ = createEffect(() => this.actions$.pipe(
        ofType<esg.EsgFileDownloadAction>(esg.ActionTypes.ESG_FILE_DOWNLOAD_ACTION),
        map(action => action.payload),
        switchMap(payload =>
            this.downloadEsgFile(payload).pipe(
                map((response: any) => {
                    // deepcode ignore DOMXSS:internally created secure response
                    downloadFile(response.body, '*/*', `${payload.csvName}.csv`);
                }),
                catchError(() => {
                    // from([
                    //     new AddErrorToastAction('Download failed. Please try again later.')
                    // ])

                    this._toasterService.launchAlertError('Download failed. Please try again later.', ActionsCDK.error);
                    return EMPTY;
                }
                )
            )
        )
    ), { dispatch: false });

    public constructor(
        private readonly actions$: Actions,
        private readonly http: HttpService,
        private readonly _toasterService: ToastService
    ) {
    }

    private loadEsgDates(payload: DatesIntervalRequest): Observable<DatesInterval> {
        return this.http.get(`/metrics/${payload.account}/date-ranges/esg`);
    }

    private loadEsg(payload: EsgRequestPayload): Observable<EsgData[]> {
        return this.http.post(`/esg/accounts/${payload.account}`, { date: payload.date, country: payload.country });
    }

    private downloadEsgFile(payload): Observable<any> {
        return this.http.post(`/esg/accounts/${payload.account}/exports`, {
            userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
            country: payload.country,
            date: payload.date,
            clientName: payload.client,
            accountNumber: payload.accountNumber,
            accountName: payload.accountName,
            esgType: payload.esgType,
            levelDrillDown: payload.levelDrillDown,
            sdgLevelThreeType: payload.sdgLevelThreeType
        }, {
            observe: 'response',
            responseType: 'blob'
        });
    }
}
